import React from 'react'
import '../../pages/style.css';
import { Container, Row, Col } from 'react-bootstrap'


function Aboutpage() {
    return (
        <div className='aboutpagebackground'>
            <Container>
                <Row className='textbackground'>
                    <Col md={7} >
                        <h3 className='aboutmetext'>About <span>Me</span></h3>
                        <p className='aboutdetails'>I'm a self-taught Front End developer and Web designer from India. I build websites with a focus on providing the experience for everyone using them and responsiveness. I am also into web designing and grapgic designing. A responsive design makes your website accessible to all users, regardless of their devices.
                        </p>
                        <ul className='skilllist'>
                            <Row>
                                <h3>Skills</h3>
                                <Col md={7}>
                                    <li>HTML5/CSS3</li>
                                    <li>JavaScript</li>
                                    <li>React JS</li>
                                    <li>Bootsrap 5</li>
                                    <li>MongoDB</li>
                                </Col>
                                <Col md={5}>
                                    <li>Adobe Illustrator</li>
                                    <li>Adobe Photoshop</li>
                                    <li>Figma</li>
                                    <li>Express.js</li>
                                    <li>Git/Github</li>
                                </Col>
                            </Row>
                        </ul>
                    </Col>
                    <Col md={5}>
                        <div className="webimage"></div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Aboutpage